import {
  INDUSTRY_FIND_ALL,
  INDUSTRY_SET_INITIAL_STATE,
  INDUSTRY_VIEW
} from './industryTypes'


const initialState = {
  data: [],
  pagination: {
    currentpage: 1,
    itemcount: 0,
    pagesize: 10,
    firstpage: '',
    lastpage: '',
    nextpages: [],
    prevpages: [],
    totalpages: 0
  },

  viewResult: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INDUSTRY_SET_INITIAL_STATE:
      return initialState;
    case INDUSTRY_FIND_ALL:
      return {
        data: action.payload.data,
        pagination: action.payload.pagination
      }
    case INDUSTRY_VIEW:
    return {
      ...state,
      viewResult: action.payload.data
    }
    default: return state
  }
}

export default reducer
